import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LoggerMonitoringService } from './logger-monitoring.service';
import { AadUser } from '../model/aad-user.model';
import { RtUser } from '../model/rt-user.model';

@Injectable({
	providedIn: 'root',
})
export class UserService {
	private userBehaviorSubject$: BehaviorSubject<RtUser> = new BehaviorSubject<RtUser>(new RtUser());
	public rtUserObs$: Observable<RtUser> = this.userBehaviorSubject$.asObservable();

	constructor(private readonly loggerMonitoringService: LoggerMonitoringService) {}

	public updateRtUser(aadUser: AadUser): void {
		const user = new RtUser();
		user.id= aadUser.claimuserid;
		user.name=aadUser.name ?? '';
		user.email=aadUser.claimusermail;
		this.userBehaviorSubject$.next(user);
		this.loggerMonitoringService.initAppInsights(user.id, user.email);
	}
}
